import React from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";

function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: "100vh", background: "#f9fafb", fontFamily: "inherit" }}>
      {/* Nav */}
      <nav className="nav">
        <div className="container">
          <div className="nav-inner">
            <div className="logo">
              <img src="/cirupay-logo-compact.svg" alt="CiruPay Logo" className="logo-image" />
            </div>
            <button className="btn" onClick={() => navigate("/")}>Back to Home</button>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="container" style={{ maxWidth: "760px", padding: "3rem 1.5rem 5rem" }}>
        <h1 style={{ fontSize: "2rem", fontWeight: 700, color: "#111827", marginBottom: "0.5rem" }}>
          Privacy Policy
        </h1>
        <p style={{ color: "#6b7280", marginBottom: "2.5rem" }}>Effective Date: May 21, 2026</p>

        <p style={prose}>
          CiruPay Inc. ("CiruPay," "we," "our," or "us") provides a digital platform that helps users organize
          and manage community-based contribution groups and recurring payment coordination.
        </p>

        <Section title="Information We Collect">
          <p style={prose}>We may collect:</p>
          <ul style={list}>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Payment-related authorization information</li>
            <li>Device and usage information</li>
            <li>Identity verification information where required</li>
          </ul>
        </Section>

        <Section title="How We Use Information">
          <p style={prose}>We use collected information to:</p>
          <ul style={list}>
            <li>Operate and improve the platform</li>
            <li>Facilitate recurring contribution coordination</li>
            <li>Prevent fraud and unauthorized activity</li>
            <li>Comply with legal and regulatory obligations</li>
            <li>Communicate with users regarding their accounts</li>
          </ul>
        </Section>

        <Section title="Payment Processing">
          <p style={prose}>
            CiruPay does not operate as a bank. Payment processing and financial transactions may be
            facilitated through regulated third-party financial infrastructure providers and payment processors.
          </p>
        </Section>

        <Section title="Data Security">
          <p style={prose}>
            We implement reasonable administrative, technical, and organizational safeguards designed to
            protect user information.
          </p>
        </Section>

        <Section title="Sharing of Information">
          <p style={prose}>We may share information with:</p>
          <ul style={list}>
            <li>Payment processors</li>
            <li>Identity verification providers</li>
            <li>Compliance and fraud-prevention partners</li>
            <li>Legal authorities where required by law</li>
          </ul>
          <p style={prose}>We do not sell personal information.</p>
        </Section>

        <Section title="User Rights">
          <p style={prose}>
            Users may request access, correction, or deletion of their personal information where applicable
            by contacting us.
          </p>
        </Section>

        <Section title="Contact">
          <p style={prose}>
            CiruPay Inc.<br />
            CiruPay Inc. — Registered in Delaware, United States.<br />
            Email: <a href="mailto:info@cirupay.com" style={{ color: "#059669" }}>info@cirupay.com</a>
          </p>
        </Section>
      </div>

      <LegalFooter navigate={navigate} />
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: "2rem" }}>
      <h2 style={{ fontSize: "1.25rem", fontWeight: 600, color: "#111827", marginBottom: "0.75rem", borderBottom: "1px solid #e5e7eb", paddingBottom: "0.5rem" }}>
        {title}
      </h2>
      {children}
    </div>
  );
}

function LegalFooter({ navigate }: { navigate: (path: string) => void }) {
  return (
    <footer style={{ background: "#111827", color: "#9ca3af", padding: "2rem 1.5rem", textAlign: "center", fontSize: "0.875rem" }}>
      <p style={{ marginBottom: "0.5rem" }}>
        <button onClick={() => navigate("/privacy")} style={footerLink}>Privacy Policy</button>
        {" | "}
        <button onClick={() => navigate("/terms")} style={footerLink}>Terms of Service</button>
      </p>
      <p style={{ marginBottom: "0.5rem" }}>
        CiruPay is a financial coordination platform and is not a bank or financial institution.
      </p>
      <p>CiruPay Inc. — Registered in Delaware, United States.</p>
      <p style={{ marginTop: "0.5rem" }}>&copy; 2026 CiruPay Inc. All rights reserved.</p>
    </footer>
  );
}

const prose: React.CSSProperties = { color: "#374151", lineHeight: 1.75, marginBottom: "0.75rem" };
const list: React.CSSProperties = { color: "#374151", lineHeight: 1.75, paddingLeft: "1.5rem", marginBottom: "0.75rem" };
const footerLink: React.CSSProperties = { background: "none", border: "none", color: "#9ca3af", cursor: "pointer", textDecoration: "underline", fontSize: "0.875rem" };

export default PrivacyPage;
